"use strict";
import { Pair } from "@uniswap/v2-sdk";
import { Pool as V3Pool } from "@uniswap/v3-sdk";
import { Pool as V4Pool } from "@uniswap/v4-sdk";
export const partitionMixedRouteByProtocol = (route) => {
  const acc = [];
  let left = 0;
  let right = 0;
  while (right < route.pools.length) {
    if (route.pools[left] instanceof V4Pool && !(route.pools[right] instanceof V4Pool) || route.pools[left] instanceof V3Pool && !(route.pools[right] instanceof V3Pool) || route.pools[left] instanceof Pair && !(route.pools[right] instanceof Pair)) {
      acc.push(route.pools.slice(left, right));
      left = right;
    }
    right++;
    if (right === route.pools.length) {
      acc.push(route.pools.slice(left, right));
    }
  }
  return acc;
};
export const getOutputOfPools = (pools, firstInputToken) => {
  const { inputToken: outputToken } = pools.reduce(
    ({ inputToken }, pool) => {
      if (!pool.involvesToken(inputToken)) throw new Error("PATH");
      const outputToken2 = pool.token0.equals(inputToken) ? pool.token1 : pool.token0;
      return {
        inputToken: outputToken2
      };
    },
    { inputToken: firstInputToken }
  );
  return outputToken;
};
